'use client'

import { selectedReferenceAtom } from '@/feature/product/services/product.store'
import { useAtom } from 'jotai'
import { useEffect, useRef } from 'react'

export function ProductReferenceSync() {
  const hasRunOnceRef = useRef(false)
  const [selectedReference, setSelectedReference] = useAtom(selectedReferenceAtom)

  // Check for reference parameter in URL on component mount
  useEffect(() => {
    if (hasRunOnceRef.current) {
      return
    }

    hasRunOnceRef.current = true

    const urlParams = new URLSearchParams(window.location.search)
    const referenceParam = urlParams.get('reference')

    if (referenceParam && referenceParam !== selectedReference) {
      setSelectedReference(referenceParam)
    }
  }, [selectedReference, setSelectedReference])

  useEffect(() => {
    return () => {
      setSelectedReference(null)
    }
  }, [setSelectedReference])

  return null
}
